import http from 'utils/http';
import { generateURLWithParams } from 'utils';

export const fetchModifiersByMerchantId = (merchantId) => http.get(generateURLWithParams(`v1/restaurants/${merchantId}/modifiers/`)).then((res) => res);
